import fontSizes from './fontSizeFakeApi';

export default class FontSizeHandler {
    constructor() {
        this.types = ['header-one', 'header-two', 'header-three', 'blockquote', 'unstyled', 'unordered-list-item', 'ordered-list-item'];
        this.fontStyles = {};
        this.fontSettings = fontSizes;
        this.baseValue = {};
        this.currentType = null;
    }

    prepareStyleObject() {
        const self = this;
        this.types.map(type => {
            this.fontSettings[type].steps.map(step => {
                return self.fontStyles[`${type}-${step.name}`] = {
                    fontSize: `${step.value}pt`,
                    lineHeight: `${step.lineHeight}pt`,
                    display: "inherit",
                    default: this.fontSettings[type].baseValue === step.value,
                }
            })
        });
        return self.fontStyles;
    }

    checkBlockType(typeToMatch) {
        return this.types.find(type => {
            return typeToMatch === type;
        })
    }

    getDefaultValue() {

    }

    getStyleKeysForType(type) {
        return Object.keys(this.fontStyles).filter(currentStyle => {
            return currentStyle.indexOf(`${type}-`) !== -1;
        });
    }

    getStylesForBlockType(type) {
        const isValidType = this.checkBlockType(type);

        try {
            if (!isValidType) {
                throw `Not Valid Block Type: ${type}. Please make sure you pass the right block type: ${this.types.toString()}`
            }
        } catch (error) {
            console.error(error);
            return {
                default: false,
                options: false,
            };
        }

        const keysForType = this.getStyleKeysForType(type);

        return {
            default: keysForType.find(type => {
                return this.fontStyles[type].default === true;
            }),
            options: keysForType.map(type => {
                return {
                    value: type,
                    option: this.fontStyles[type].fontSize,
                    default: this.fontStyles[type].default
                }
            })
        }

    }

}



// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/custom-methods/FontSizeHandler.js